import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

const InsideWrapper = styled.div<{ yPos: number; yPos2: number }>`
  position: relative;
  width: 100%;
  z-index: 1;

  @media all and (min-width: 450px) {
    margin: -50px 0 50px 0;
  }
`;

export const Overlap: React.FC<{ yPos: number; yPos2?: number }> = ({
  children,
  yPos,
  yPos2,
}) => {
  return (
    <Wrapper>
      <InsideWrapper
        yPos={yPos}
        yPos2={yPos2 != null && yPos2 != undefined ? yPos2 : yPos}
      >
        {children}
      </InsideWrapper>
    </Wrapper>
  );
};
